export const common = { // 公共
  inputContentTip: 'Please enter the content',
  sendKeywordTip: 'Tell me what\'s going on and I\'ll look for an answer. If I can\'t find the answer you need, I\'ll get you additional help.',
  readArticle: 'Read article',
  vsCodeSendSuc: 'Verification code sent',
  industrySkillExist: 'Industry skill exist',
  industryExist: 'Industry exist',
  bindPhone: 'Bind phone',
  bindEmail: 'Bind email',
  notSet: 'Is not set',
  alreadySet: 'Already set',
  unbound: 'Unbound',
  bound: 'Verified',
  networkException: 'Network exception',
  momentAgo: 'Moment ago',
  minutesAgo: ' minutes ago',
  hourAgo: ' hour ago',
  weekAgo: ' week(s) ago',
  monthsAgo: ' month(s) ago',
  daysAgo: ' day(s) ago',
  confirm: 'confirm',
  deleteTip: 'Are you sure to delete?',
  describe: 'Describe',
  describeNullTip: 'Please fill in the description',
  pleaseSelect: 'Please select',
  noData: 'No data',
  inputNumTip: 'Please enter a number',
  operationFailed: 'Operation failed',
  remarks: 'Remarks',
  successTip: 'Operation succeeded',
  reminder: 'Reminder',
  saveSuc: 'Saved successfully!',
  saveFailed: 'Save failed!',
  searchTip: 'Please enter keywords',
  search: 'Search',
  toRecharge: 'To recharge',
  login: 'LOGIN',
  logOut: 'Log Out',
  signUp: 'SIGN UP',
  home: 'HOME',
  project: 'PROJECT',
  myProject: 'MY PROJECT',
  bidProject: 'BID PROJECT',
  postProject: 'POST PROJECT',
  allProject: 'All Project',
  exploreTopSkills: 'Explore Top Skills',
  msg: 'Message',
  chatMsg: 'Chat Message',
  P_E_T_S_C: 'Please enter the search content',
  page_total1: '共',
  page_total2: '',
  changeLang: '切换语言',
  cancel: 'Cancel',
  submit: 'Submit',
  close: 'Close',
  yes: 'Yes',
  analyst: 'Talent',
  customer: 'Client',
  bidder: 'Bidder',
  reset: 'Reset',
  query: 'Query',
  verificationCode: 'Verification Code',
  tips: 'Tips',
  bankCardTip: 'Your bank card information (collection information) is not perfect, please perfect before bidding.',
  userInfoTip1: 'Your personal information is not yet complete. Please upload your avatar and modify your name first.',
  userInfoTip2: 'Your personal information is not yet complete. Please upload your avatar first.',
  userInfoTip3: 'Your personal information is not yet complete. Please modify your name first.',
  goTo: 'GO TO',
  points: 'Credit',
  other: 'Other',
  systemMessage: 'System Message',
  timedTaskManage: 'Timed Task Manage',
  save: 'Save',
  email: 'Email',
  userName: 'User name',
  days: 'Day(s)',
  recentContent: 'Recent highlights',
  sendCode: 'Get code',
  resendCode: 'Resend code',
  uploadSuccess: 'Upload successful',
  uploadFailed: 'Upload failed',
  noData: 'No data',
  delete: 'Delete',
  feedback: 'Infotikx feedback',
  feedbackTips: 'Please let us know what happened and we will reply to you as soon as possible.',
  feedback:'Feedback',
  feedbackChatTip: 'Please let us know what happened...',
  reply: 'Optional, we will reply to you as soon as possible',
  footerCompany:'InfoTikx is a brand owned and operated by Kcomber,Inc.',
  footerReserved:'Kcomber,Inc. All rights reserved.' ,
  businessConsulting:'Business consulting',
  Tel:'Tel',
  Email:'E-mail',
  currency:'RMB',
  payment:'One time delivery',
  byStages:'Installment delivery',
  renovate: 'Operation failed，Please refresh the page and try again!',
  ok: 'OK',
  noSet:"Not set temporarily",
  help:'How can we help you?',
  categories:'Categories',
  support:'Support',
  verificationFailure: 'Verification failure',
  drag: 'Complete the puzzle',
  set:'Setting',
  supports: "Support",
  collection:'My collection',
  collectionIsMore:'Your favourite list is full. You can purchase Membership to having bigger list and more functions.',
  success:'Collection success',
  noPoints:'Credit not enough',
  publicTotal:'Private biding',
  loadingTip: 'Loading...',
  inviteProject: 'Please select the project to invite bid',
  fireworksTips:'Talents are on their way',
  pleaseConfirm: 'Confirmation',
  confirmNameTip1: 'Please confirm the',
  confirmNameTip2: 'role name will be updated to：',
  updateEmail: 'and update your email address as:',
  updatePhone: 'and update your cellphone number as:',
  updateNicknameTip1: 'It can only be modified once a year',
  updateNicknameTip2: 'Both of them can only be modified once a year',
  updateNicknameTip3: 'Both of them can only be modified once a year',
  mailboxValidated: 'Mailbox validated',
  phoneValidated: 'Mobile phone validated',
  stop: 'TO',
  confirm: 'confirm',
  cancel: 'cancel',
  copyLink:'Copy link',
  shareLink:'Share this profile with others',
  copyToClipboard:'Copy to clipboard',
  copuSuccess:'Copied!',
  share:'share',
  fillInTheNewInformation:'Fill in the new information',
  transactionHistory: 'Transaction history',
  finance: 'Finance',
  myWallet: 'My wallet',
  recharge: 'Recharge',
  chatting: 'Customer service chat'
}

export const login = { // 登录页面
  loginTip: 'Please login first',
  login: 'Login',
  signIn: 'Sign in',
  passwordSignIn: 'Password sign in',
  emailSingIn: 'Email code sign in',
  phoneSingIn: 'Mobile login',
  forgotPassword: 'Forgot password?',
  userName: 'User name',
  password: 'password',
  enterUserNameOrEmailOrPhone: 'Please enter your userID、email or phone number',
  enterEmail: 'Enter email',
  enterPhone: 'Enter phone',
  onlyChinesePhoneTip: 'Only Chinese mobile phones are supported',
  emailAddress: 'Email address',
  inputPassword: 'Please input a password',
  retrievePassword: 'Retrieve password',
  retrievePasswordTip: 'Please fill in the account number you need to retrieve',
  nextStep: 'Next step',
  enterYourEmail: 'Please enter your email address or account number',
  newPassword: 'New password',
  confirmNewPassword: 'Confirm new password',
  enterOldPassword: 'Please enter the original password',
  loginFailTip: 'Incorrect account or password',
  userNameOrEmailOrPhone: 'Account id/Email/Phone',
  notLoginTip: 'No login or login timeout, please login',
  loginCodeError: 'Verification code error',
  emailNotExistAccount: 'There is no corresponding account in this mailbox',
  phoneNotExistAccount: 'There is no corresponding account in this phone',
  enterEmailLoginCode: 'Enter email login code',
  codeLogin: 'Code login',
  emailOrAccountErrorTips: 'Email or account number does not exist, please re-enter',
  userInfoEmptyTip: 'Account does not exist',
  sendSuccess: 'The verification code was sent successfully and is valid for 15 minutes',
  modifiedSuccess: 'Modified successfully',
  isNoAnalyst:'Talent role cannot publish project, heading to homepage',
  isNoCustomer:'Client role unavailable for bidding, heading to homepage',
  phone:'phone'
}

export const signUp = { // 注册

  failToRegister700:"Registration failed. Please check what you entered",
  failToRegister1001:"The username cannot be null",
  failToRegister1002:"The user password cannot be empty",
  failToRegister1010:"Account names cannot contain the [@] character",
  failToRegister1011:"Account names cannot be pure numbers",
  failToRegister1003:"The account length must be between 2 and 20 characters",
  failToRegister1004:"The password must be between 5 and 20 characters long",
  failToRegister1005:"Registration failed. The username is already registered",
  failToRegister1006:"Registration failed, the mailbox has been registered",
  failToRegister1007:"Registration failed, the phone number has been registered",
  emailExists: 'This mailbox is already registered',
  alreadyAccountTip: 'Already have an account? Log In',
  protocolTipTwo: '《User agreement and terms》',
  protocolTipOne: 'Read and accept',
  noSpacesAllowed:"The password cannot be a space",
  protocolUncheckedTip: 'Please tick "Read and accept the Intotikx user agreement"',
  chooseRoleTip: 'Please select your role',
  signUpFromPhoneTip01: 'Please enter your mobile phone number, you will receive our registration verification sms, or ',
  signUpFromPhoneTip02: 'register by email',
  signUpFromEmailTip01: 'Please enter your email, you will receive our registration verification email, or ',
  signUpFromEmailTip02: 'register with your mobile number',
  phoneNullTip: 'Please enter your mobile phone number first',
  phone: 'Phone',
  registerViaEmail: "Sing up from email",
  registerViaPhone: "Sing up from phone",
  signUpError: 'System exception, registration failed',
  userNameExists: 'User name already exists',
  parameterException: 'Parameter exception',
  codeErrorTip: 'Verification code error',
  FailedToChangePassword1012:"Failed to change password, old password wrong",
  FailedToChangePassword1013:"The new password cannot be the same as the old password",
  keyError:"Abnormal email or mobile phone",
  emailExistTip: 'The mailbox is already registered to another account!',
  phoneExistTip: 'The phone is already registered to another account!',
  resend: 'Resend',
  resendCodeTip: 'Resend code',
  sendCodeErrorTip: 'Service unavailable, verification code sending failed, please try again later',
  sendCodeSucTip: 'The verification code has been sent',
  sendCodeSuc10Tip: 'The verification code has been sent, valid for 10 minutes',
  sendCodeSuc15Tip: 'The verification code has been sent, valid for 15 minutes',
  sendCodeEmailErrorTip: 'Failed to send verification code. Email address cannot be empty',
  registerSuccessTip: 'Register success',
  enterVerificationCodeTip: 'Please enter the verification code',
  greaterThan6CharTip: 'Cannot be less than 6 characters',
  inputPasswordTip: 'Please input a password',
  enterOldPassword: 'Please enter the original password',
  emailErrorTip: 'Please enter the correct email address',
  phoneErrorTip: 'Please enter the correct phone',
  enterEmailTip: 'Please enter email address',
  enterNicknameTip: 'Please enter a nickname',
  greaterThan60Characters: 'Cannot be greater than 60 characters',
  enterUserNameTip: 'Enter one user name',
  getVerificationCode: 'Get code',
  passwordInconsistentTip: 'The two passwords are inconsistent!',
  enterPasswordAgainTip: 'Please enter the password again',
  signUp: 'Sign up',
  userName: 'User name',
  password: 'Password',
  enterUserName: 'enter one user name',
  inputPassword: 'Please input a password',
  confirmPassword: 'Confirm password',
  nickname: 'Nickname',
  email: 'Email',
  emailOrPhone: 'Email/Phone',
  verificationCode: 'Verification code',
  mailboxBeingValidated: 'Mailbox being validated',
  retrievingAccountTip: 'The account you are retrieving is: ',
  ToHire: 'To hire',
  findWork: 'Find work',
  EmailCode:'Email verification code'
}

export const project = { // 项目相关
  createNewProject: 'Create a new project',
  projectDetails: 'Project details',
  bidOwnProjectTip: 'You cannot bid for projects published by yourself',
  projectId: 'Project ID',
  update: 'Update',
  skills: 'Skills',
  industryAndSkill: 'Industry & Skills',
  evaluation: 'Evaluation',
  projectCase: 'Project case',
  effective: 'Effective',
  beOverdue: 'Be overdue',
  evaluated: 'To be evaluated',
  beOverdueProject: 'Be overdue project',
  canceled: 'Canceled',
  projectTitleExist: 'Project title exist',
  paymentProportionsTop: 'The sum of payment proportions must be 100%',
  projectProportionsTop: 'The sum of project proportions must be 100%',
  proportionsTip: 'The total proportion is not 100%',
  daysEmptyTop: 'Days cannot be empty',
  upLoadMaxTop: 'You can only upload up to 3 attachments',
  badeTip: 'You have participated in the bidding. Submit again to modify the bidding information',
  stage: 'Product delivery by installments',
  repeatBiddingTip: 'You have participated in the bidding of this project. Please do not submit it again',
  projectNotInBidding: 'Submission failed. The bidding for this project has ended',
  publicProject: 'Public project',
  privateProjectNotInvTip: 'For private projects, at least one talent needs to be invited',
  privateProjectTip: 'If it is checked as a private project, only invited talent can view and participate in bidding',
  privateProject: 'Private project',
  costTip: 'Please enter cost',
  cost: 'Cost',
  durationTip: 'Please enter duration',
  duration: 'Duration',
  next: 'Next',
  fileSizeErrorTip: 'The file size exceeds the limit. The system has removed it from the upload list. Please upload again!',
  fileTypeErrorTip: 'Uploading this file format is not supported. It has been removed from the upload list. Please upload it again!',
  editProjectTip: 'The project is in bidding / trading / acceptance status. Please modify the project content carefully. After modification, the system will automatically send an email to inform the bidder and the winning bidder (if any), continue?',
  saveAndPost: 'Save & Posh',
  existTip: 'Already exists, please do not add again!',
  invitationTip: 'The user cannot be queried. You can enter his email address and send him an invitation email!',
  registeredEmailInvited: 'Registered mailbox to be invited',
  analystsInvited: 'Talents to be invited',
  enterProjectDuration: 'Please enter the project duration',
  enterBudgetTip: 'Please enter budget',
  relProPointsTip: 'Coupons are required for this release',
  pointsCurrentlyOwnedTip: 'Credit currently owned',
  all: 'ALL',
  unpublished: 'Unpublished',
  noBid: 'No bid',
  bidding: 'Bidding',
  trading: 'Trading',
  inReview: 'In review',
  completion: 'Completed',
  closed: 'Closed',
  bidder: 'Bidder',
  releaseTime: 'Release time',
  C_T_V_P_D: 'Click to view project details',
  biddingProject: 'Bidding project',
  joinBid: 'Join bid',
  postProject: 'Publish project',
  postProjectSucTip: 'Project published successfully',
  bidProject: 'Bid project',
  projectTitle: 'Project title',
  category: 'Category',
  subCategory: 'Sub category',
  projectDescription: 'Project description',
  requiredSkills: 'Required skills',
  budget: 'Budget (yuan)',
  budgetDuration: 'Budget duration (days)',
  durationMin: 'Min budget duration',
  durationMax: 'Max budget duration',
  durationMinTip: 'Please enter the shortest budget duration (integer)',
  durationMaxTip: 'Please enter the longest budget duration (integer)',
  biddingDeadline: 'Bidding deadline',
  attachFile: 'Attach file',
  additionalDocumentDescription: 'Up to one attachment can be uploaded, with 5 maximum of 20MB for each file. The supported formats are. JPG,. PNG,. PDF,. Docx,. Doc,. Xlsx,. XLS,. Pptx,. Ppt,.RAR,ZIP',
  additionalDocumentDescription2: 'Up to one attachment can be uploaded, with 1 maximum of 20MB for each file. The supported formats are. JPG,. PNG,. PDF,. Docx,. Doc,. Xlsx,. XLS,. Pptx,. Ppt,.RAR,ZIP',
  markAsFeatured: 'Mark as featured',
  invitationAnalyst: 'Invitation talent',
  paymentMethod: 'Payment method',
  wechatPay: 'WechatPay',
  aliPay: 'AliPay',
  offlineTransfer: 'Offline transfer',
  payAndSubmit: 'Pay and submit',
  iHavePaid: 'I have paid',
  enterTitle: 'Please enter a title',
  selectCategory: 'Please select a category',
  selectSubCategory: 'Please select a sub category',
  titleMinCharacter: 'Please enter at least 10 characters',
  titleMaxCharacter: 'Please enter at most 255 characters',
  enterProjectDescription: 'Please enter project description',
  descriptionMinCharacter: 'Please enter at least 30 characters',
  descriptionMaxCharacter: 'Please enter at most 4000 characters',
  selectRequiredSkills: 'Please select the required skills',
  selectDeadlineForBidding: 'Please select the deadline for bidding',
  editProject: 'Edit project',
  allCategory: 'All category',
  skills: 'Skills',
  budgetScope: 'Budget scope',
  budgetMax: 'Budget max',
  budgetMin: 'Budget min',
  budgetMaxTip: 'Please enter the maximum budget (integer)',
  budgetMinTip: 'Please enter the minimum budget (integer)',
  featured: 'Featured',
  nothing: 'Nothing',
  biddingProjectRemarksTip: 'Please enter the bidding remarks',
  clickToDownload: 'Click to download',
  projectDetails: 'Project details',
  tradeDetails: 'Transaction details',
  uploadAttachment: 'Upload attachment',
  uploadAttachmentTip: 'Up to 3 attachments can be uploaded',
  remark: 'Remark',
  submitRemark: 'Submit remark',
  deliver: 'Deliver',
  enteringTheAcceptanceStage: 'Entering the acceptance stage',
  enteringTheAcceptanceStageTip: 'Are you sure to enter the acceptance stage?',
  checkAndAccept: 'Check and accept',
  currentPhase: 'Current delivery phase',
  attachments: 'Attachments',
  analystRemark: 'Talent remark',
  acceptancePassed: 'Acceptance passed',
  acceptancePassedTip: 'Are you sure the project has passed the acceptance?',
  acceptanceFailed: 'Acceptance failed',
  acceptanceFailedTip: 'Are you sure you want to reject the project?',
  onlyNewComers: 'Only new comers',
  successfulBidder: 'Successful bidder',
  choice: 'Choice',
  select: 'Select',
  releaseTime: 'Release time',
  deadline: 'Deadline',
  projectTreatyTip: 'Please read and agree to the infotikx terms of service',
  projectTreaty: 'I have read and agree to the ',
  pay: 'PAY',
  aliPayTip: 'Please scan the payment with Alipay',
  weChatPayTip: 'Please scan the payment with wechat',
  researchFeeOrder: 'Research fee order',
  goToBidding: 'Go to bidding',
  containsEmailTips: 'It is not recommended that messages such as e-mail and telephone appear. By default, the system replaces e-mail and telephone with xx...xx',
  biddingTips: 'Total bid amount and total bid duration budget',
  file: 'file',
  fileLimit3: 'only one attachment can be uploaded at most',
  fileLimit4: 'You can upload a maximum of 5 attachments',
  isRemove: 'remove',
  deleteSuccess: 'Deleted successfully!',
  previousStep: 'Previous step',
  pleaseEnter: 'Please enter a number',
  successfully:'Success',
  whatCanweDo:'What can we do for you',
  improveInformation: 'Continue to improve project information',
  submitInformation:'Submit information and we will quickly help you match professional service personnel',
  tellprojectTitle:'Tell us the project title',
  aboutProject:'Tell us more about the project',
  uploadFile:'Upload file',
  projectInformation:'Basic information of the project you have submitted',
  fillInformation:'Continue to fill in the information to publish the project',
  costBudget:'Project cost budget',
  expect:'Estimated duration',
  expectTime:'in',
  deliveryType:'Project Delivery Type',
  publication:'Project Publication Type',
  outward:'Open bidding',
  secret:'Private bidding',
  preview:'Preview project information',
  expectedCompletion:'Estimated completion period',
  cutOffDate:'Bidding deadline',
  saveDraft:'Save Draft',
  userAgreement:'《User Agreement of InfoTikx》',
  inviteEmail:'Invited talent email',
  invitationEmail: 'Invitation Email',
  inviteTalents: 'Invite talents',
  InviteBidding: 'Invite talents for bidding',
  cooperate: 'People you have worked with',
  selectProject: 'Please select your project',
  postbox:'Incorrect mailbox format',
  remove:'Remove',
  addStages:'Add Stages',
  invitation:'Invitation to bid',
  hire: 'Hire',
  progress:'Projects in progress',
  toBeReleased:'Items to be released',
  closedItems:'The finished project',
  isPrivate:'Private',
  skillRequirements:'Skill requirement(s)',
  endTime:'Time remaining',
  estimate: 'Estimated duration',
  completionTime: 'Expected completion period',
  averageBiddingAmount: 'Average bidding amount',
  numberOfBidders: 'bidder(s)',
  successfulBidder: 'Successful Bidder',
  projectInfo: 'Project Information',
  biddingList: 'Bidding List',
  endOfBidding: 'The tender has been closed',
  projectNo:'Project No',
  deadlineBidding:'Deadline for bidding',
  exposedType:'Exposed Type',
  paymentType:'Project payment type',
  employer:'Project employer',
  biddingInformation:'Fill in bidding information',
  biddingAmount: 'Bidding amount',
  bestCandidate: 'What makes you the best candidate for this project ?',
  bid: 'Go to bid',
  averageBid: 'Average bid',
  noMoreData: 'No more data',
  invitationList: 'Added to invitation list',
  alreadyExists: 'This talent has been invited ！',
  maximum: 'Invite up to 5 talents',
  matching: 'The platform is rapidly matching talents',
  recruit: 'Recruiting talents',
  backToHome: ' seconds return to home page ',
  backToProject: ' seconds return to project page ',
  cooperation: 'Determine cooperation',
  startChat: 'Start a chat',
  initiateCooperation: 'Initiate cooperation',
  projectBudget: 'Expense budget',
  release: 'Released in',
  bidEnd: 'End',
  expirationTime:'Expiration time',
  projectCompletionTime: 'Project completion time',
  projectExposedType: 'Project Publication Type',
  deliveryMethod: 'Delivery method',
  projectCost: 'Project cost',
  projectProgress: 'Project progress',
  attachmentContent: 'Attachment content',
  records: 'View detailed records',
  deliverables: 'Deliverables',
  deliveryPhase: 'Delivery phase',
  results: 'The results are under production...',
  evaluationInformation: 'Evaluation information',
  evaluationScore: 'Your evaluation score:',
  evaluateComments: 'Your evaluation content:',
  detailRecord: 'Detail record',
  startTime: 'Project start time',
  addDeliverables: 'Upload File',
  Failure: 'Failure in acceptance',
  Accepted: 'Accepted',
  noComments: 'No evaluation information',
  beenCommented: 'The other party has submitted a comment. You need to review before displaying your comment',
  checkStage: 'Current acceptance stage',
  yesOrNo: ', Whether the acceptance is passed? After approval, the project cost will be released from the platform to the winning bidder account.',
  failed: ', failed to pass the acceptance',
  failedReason: 'Please fill in the reason for failure',
  caht: 'Chat',
  failedReason1: 'Please fill in the reason for failure of acceptance!',
  public:'Public bidding',
  nonPublic:'Private bidding',
  tips1:'Free times:',
  tips2:'  (Spend 5 credit',
  noChange:'Bidding type cannot be modified',
  achivement:'achivement',
  isInvite:'Invited',
  veryPoor:'Very poor',
  disappointed:'Disappointed',
  average:'Average',
  satisfied:'Satisfied',
  surprised:'Surprised',
  paymentSummary: 'Payment Summary',
  requested: 'Requested',
  inProgress: 'In Progress',
  releaseMoney: 'Release to Talent',
  requestCreate: 'Requested',
  created: 'Created',
  funded: 'Funded',
  releaseRequested: 'Release Requested',
  released: 'Released',
  reject: 'Reject',
  accept: 'Accept',
  refuse: 'Refuse',
  payment: 'Payment',
  milestone: 'Milestone',
  milestonePayments: 'Milestone Payments',
  milestoneAmount: 'Milestone Amount',
  milestoneDescription: 'Milestone Description',
  status: 'status',
  inputAmount: 'Please enter the amount',
  inputDesc: 'Please enter a description',
  endProject: 'End Project',
  milestoneNo: 'Milestone NO',
  proposals: 'Proposals',
  files: 'Files',
  paymentInfo: 'Payment',
  invalidBid: 'Invalid Bid',
  retractBidTips: 'Are you sure you want to cancel the current bid?',
  retractBidding: 'Retract',
  releaseConfirm: 'Confirm release of payment',
  releaseConfirmTips:'please ensure that you are satisfied with the work, as Milestone Payments cannot be returned once released, The project will become completed.',
  confirmCloseProject: 'Confirm end project',
  closeProjectTips:'Once the project is cancelled, it will become closed.',
  requestCancel:'Cancel Requested',
  canceled:'Cancelled',
  uploadFileTips: 'Please upload the results file first',
  cancelProjectTips: 'Projects with funding milestones cannot be cancelled',
  withdrawCancel: 'Withdraw Cancel',
  completeProjectRadio: 'I am satisfied that all my project requirements have been met',
  closeProjectRadio: 'Close the project',
  disputing: 'Disputing',
  createDispute: 'Create Dispute',
  viewDispute: 'View Disputes'
}

export const user = { // 用户相关
  informationIntroduction: 'Information introduction',
  hisProfile: 'His profile',
  currentlyBoundPhone: 'Currently bound Phone number',
  currentlyBoundEmail: 'Currently bound E-mail',
  modifyBoundEmail: 'Modify bound E-mail',
  enterUserIdTip: 'Please enter your new userID',
  enterNickNameTip: 'Please enter a user role name',
  modifyUserId: 'Modify account id',
  modifyNickName: 'Changing a Role Name',
  bindPhoneTip: 'Use your phone number as your account name to log in. You can change it only once a year.',
  phoneBinding: 'Phone',
  verificationType: 'Verification by other means',
  noEmail: 'The current account is not bound to the relevant E-mail!',
  refuseToSend: 'The E-mail registration less than 7 days can not be tied!',
  phoneTip: '(User your phone number as your account name to log in.You can change it only once a year.)',
  updateNickNameTip: 'It can only be modified once a year',
  modifyUserIdTip: 'Be careful you may only change it once',
  modifyEmailTip: 'Your Email can only be updated once a year',
  registrationDate: 'Registration date',
  modify: 'Update',
  binding: 'Add',
  bindingUpdate: 'Update',
  accountSecurity: 'Account Security',
  idAlreadyExists: 'ID already exists',
  idCannotContainTip: 'ID cannot contain ` @ `、 `! `、`$`、`?`、`&`、`#`、`*`... symbol',
  idStartWithUserTip: 'ID cannot be `user_` start',
  idMaxLengthTip: 'ID cannot be greater than 20 characters',
  idMinLengthTip: 'ID cannot be less than 6 characters',
  nicknameLengthTip: "The username must be between 3 and 16 characters long",
  idAllNumTip: 'ID cannot be a pure number',
  ninckNameTip: 'The role name cannot be empty',
  idEmptyTip: 'ID cannot be empty',
  nickNameTip: 'The role name cannot be empty',
  nickkNameTip2: 'The role name must begin with a letter',
  nickkNameTip3: 'Duplicate character name. Try another one',
  nickkNameTip4: 'Please fill in a legal name',
  retrievingPasswordUserIdTip: 'Retrieving password userId',
  useEmailToValidateTip: 'Switch to email verification',
  usePhoneToValidateTip: 'Switch to mobile phone verification',
  emailBeingVerifiedTip: 'Email being verified',
  phoneBeingVerifiedTip: 'Phone number being verified',
  emailNotBoundTip: 'Unbound mailbox',
  phoneNotBoundTip: 'Unbound phone',
  canNotUpdateByKeyTip: 'You cannot reset your password in this way',
  updatePasswordError: 'Update password error',
  mailboxInUse: 'Mailbox in use',
  chooseRoleAanExplain: 'Talent bid and implement projects to obtain the benefits of services.',
  chooseRoleCusExplain: 'Clients publish their needs and cooperate with high-quality service providers within the platform.',
  currentUserId: 'Current UserID',
  currenntNickName: 'Current Role Name',
  userId: 'Account ID',
  user: 'User',
  userType: 'User type',
  personal: 'Account Details',
  myProfile: 'My profile',
  editProfile: 'Edit profile',
  changePassword: 'Change password',
  bankCard: 'Bank Card',
  setNewPassword: 'Set a new password',
  account: 'Account',
  password: 'password',
  enterNewPassword: 'Please enter a new password',
  submit: 'Submit',
  safetyVerification: 'Safety Verification',
  updatePasswordTips: 'In order to ensure the security of the account, it is necessary to verify the identity before changing the password',
  verifyMailbox: 'Verify Mailbox',
  verificationCode: 'Verification Code',
  getCaptcha: 'Get Captcha',
  newPasswordEmptyTips: 'New password cannot be empty',
  resendVerificationCode: 'Resend verification code',
  myProfile: 'My profile',
  aboutMe: 'About Me',
  totalRevenue: 'Total revenue',
  totalSpent: 'Total spent',
  completedProjects: 'COMPLETED PROJECTS',
  ongoingProjects: 'ONGOING PROJECTS',
  nickname: 'Nickname',
  email: 'Email',
  phone: 'Phone',
  type: 'Type',
  skills: 'Skills',
  level: 'Level',
  entry: 'Entry',
  reviews: 'Reviews',
  avatar: 'Avatar',
  editAvatar: 'Update Profile Picture',
  addAvatar: 'Photo',
  editAvatarTip: 'Only jpg / jpeg / PNG files can be uploaded',
  score: 'Score',
  reviewsAndRatingsTip: 'Pro, write some comments. Your comments are very helpful to other clients',
  evaluationContentCannotBeEmpty: 'Evaluation content cannot be empty',
  youHavenScoredYet: 'You haven\'t scored yet',
  userStatistics: 'User Statistics',
  accountId: 'Id',
  evaluateSucTip: 'Evaluate success!',
  relatedItems: 'Related items',
  noComment: 'There are no comments and scores!',
  profile: 'Profile',
  mySettings: 'My settings',
  privacySettings: 'Privacy settings',
  otherSettings: 'Other settings',
  showAllItem: 'Show all item quantities',
  displaysUnsuccessful: 'Displays the number of unsuccessful projects',
  displaysReleased: 'Displays the number of items to be published',
  displaysBid: 'Displays the number of items in the bid',
  displaysTransaction: 'Displays the number of items in the transaction',
  displaysAcceptance: 'Displays the number of items in acceptance',
  displaysCompleted: 'Displays the number of completed projects',
  displaysClosed: 'Displays the number of closed items',
  displayEvaluation: 'Show comments and ratings',
  avatarReview: 'Avatar review',
  mailboxRelated: 'Mailbox related',
  receiveBiddingEmail: 'Open auction email notification',
  AvatarModifiedSuccessful: 'Avatar modified successfully!',
  AvatarModifiedFailed: 'Avatar modification failed!',
  ResendAfter1: 'Resend after ',
  ResendAfter2: 's',
  sendSuccess: 'send successful',
  BasicInfo: 'Basic info',
  tips1: 'User type and user name are not certified yet. ',
  tips2: 'To get certified',
  Character: 'Character',
  UserID: 'Account ID',
  UserType: 'User type',
  Individual: 'Individual',
  Company: 'Company',
  Services: 'Services',
  Skill: 'Skill',
  Contact: 'Contact',
  PhoneNumber: 'Phone number',
  Email: 'E-mail',
  Country: 'Country/Region',
  Province: 'State/Province',
  city: 'City',
  Detailed: 'Detailed address',
  PostalCode: 'Postal code',
  Medals: 'Medals',
  MyMedals: 'My medals',
  Picture: 'Picture of qualification certificates',
  CompanyName: 'Company name',
  Unbound: 'Unbound',
  tips3: 'Please bind account to a mobile phone number first.',
  tips4: 'To bind',
  DocumentType: 'Document type',
  DocumentNo: 'Document No.',
  DocumentPhotocopy: 'Document photocopy',
  CompanyType: 'Company type',
  BusinessLicense: 'Business license',
  BusinessLicenseNo: 'Business license No.',
  LicensePhotocopy: 'License photocopy',
  tips5: 'I certify that the information given herein is true and valid to the best of my knowledge.',
  tips6: 'The applicant certifies that the information of the company given herein is true and valid.',
  customer: 'client',
  analyst: 'talent',
  NotAuthenticated: 'Not authenticated',
  UserName: 'User name',
  DataCompleteness: 'Profile Completion',
  PleaseSelect: 'Please select',
  PleaseEnter: 'Please enter',
  save: 'Save',
  cancel: 'Cancel',
  tips7: 'Industry Service Skills Selection',
  tips8: 'Please select company type',
  tips9: 'Username can not be empty',
  tips10: 'Please select document type',
  tips11: 'Please enter the ID number',
  tips12: 'Please tick the confirmation box',
  tips13: 'Company name cannot be empty',
  tips14: 'Please select company type',
  tips15: 'Please select document type',
  tips16: 'Enter the ID number',
  tips17: 'Please tick the confirmation box',
  tips18: 'please enter user name',
  withdrawal: 'My E-wallet',
  accountFunds: 'Account Funds',
  WithdrawalTips: 'Withdrawal Tips',
  tips19: 'Offline withdrawals are expected to be credited to your account within 7-15 business days',
  tips20: 'Please upload your profile picture',
  AccountBalance: 'Account Balance',
  withdraw: 'Withdraw',
  WithdrawalsRecord: 'Withdrawals record',
  startDate: 'Start date',
  endDate: 'End date',
  ApplicationDate: 'Withdrawal application date',
  WithdrawalAmount: 'Withdrawal Amount',
  AccountsReceivable: 'Accounts receivable',
  WithdrawalStatus: 'Withdrawal status',
  aboutME: 'About me',
  privateEnterprise: 'Private enterprise',
  stateOwnedEnterprise: 'State-owned enterprise',
  IDNumber: 'ID Number',
  passport: 'Passport',
  BusinessRegistration: 'Business registration',
  other: 'Other',
  ExcellentTest: 'Excellent test',
  punctual: 'Punctual',
  highQuality: 'High-quality',
  UnboundPhone: 'Unbound, go to bind mobile phone',
  UnboundEmail: 'Unbound, go to the bound mailbox',
  FullName: 'Full name',
  uploadDescription: 'Only jpg/png/jpeg files with a maximum size of 2MB can be uploaded',
  withdrawMoreDay:'The number of withdrawals has reached the upper limit today',
  withdrawMoreMon:'The number of withdrawals has reached the upper limit of this month',
  NumberOfWithdrawalsThisMonth:'Number of withdrawals this month',
  moreSkill:'The number of skills exceeds the current member level limit',
  currentTip: 'Current',
  countryTip: 'Please select the current country/region',
  notificationsettings:'Notificationsettings',
  onlineMessage:'Online message',
  email:'Email',
  messageNotification:'Systematic Notification',
  financialNotice:'Financial Notification',
  memberNotification: 'Member Notification',
  projectRelated: 'Project Related',
  descTips: 'Description cannot be empty',
  amountTips: 'The amount is illegal!',
  amountTips1: 'Amount cannot be 0!',
  amountTips2: 'Amount cannot be empty!',
  amountTips3: 'Less than total amount!',
  checkUserInfoTip1: 'Please add an avatar and change your nickName',
  checkUserInfoTip2: 'Please add an avatar',
  checkUserInfoTip3: 'Please change your nickName',
}

export const msg = { // 消息相关
  msgCenter: 'Message center',
  all: 'ALL',
  title: 'Title',
  sendTime: 'Send time',
  operate: 'Operate',
  show: 'Show',
  close: 'Close',
  chatMsg: 'Chat message',
  chatTip: 'Please enter the content',
  send: 'Send',
  sendMsgTip: 'You cannot send a blank message',
  startPrivateChat: 'Start a private chat',
  remarkRepeat: 'You have evaluated, please do not submit again',
  content:'Content',
  isAll:'All message has been loaded',
  onlineService:'Online Service',
  markAsRead: "Mark as Read",
  markUnread: "Mark as Unread",
  markAllAsRead: "All read",
  markAllUnread: "All unread",
  allReadConfirm: 'This operation will set all messages as read. Do you want to continue?',
  allUnreadConfirm: 'This operation will set all messages as Unread. Do you want to continue?',
  readConfirm: "Are you sure you want to set this message as read",
  unreadConfirm: "Are you sure you want to set this message as unread",
  noMsg:'No message',
  chatRules:'Chat rules',

}

export const bankCard = { // 银行账户相关
  perfectBankCardTip: 'Your bank card information is incomplete',
  myBankCard: 'My bank card',
  bankCardType: 'Bank card type',
  personal: 'Personal',
  mechanism: 'Mechanism',
  bankAccountName: 'Bank account name',
  bankAccount: 'Bank account',
  nameOfBankOfDeposit: 'Name of Bank of deposit',
  bankBranch: 'bank branch',
  save: 'Save',
  editBankCardTip: 'If there is no agreement with InfoTikx, please declare your own personal income tax',
  SetAsDefault: 'Set as default',
  AddBankCard: 'Add bankcard',
  holderName: 'Please enter the holder name',
  bankName: 'Please enter the bank name',
  bankAddress: 'Please enter bank address',
  bankNo: 'Please enter SWIFT Code, Branch Code',
  bankCardNo: 'Please enter IBAN',
  manageBankCards: 'Manage bank cards',
  addACard: 'Add a card',
  bankCardMaxTip: 'Bind up to 5 bank cards',
  withdrawalOfAmount: 'Withdraw',
  arrivalAccount: 'To bank account',
  addCard: 'Add a new card',
  withdrawer: 'Withdraw',
  amount: 'Amount',
  balance: 'Balance',
  tips1: 'Read and accept the',
  agreement: 'Withdrawal Service Agreement',
  tips2: 'Please tick the read and accept the Withdrawal Service Agreement',
  withdrawalNo: "Withdrawal No",
  createTime: 'Create Time',
  applyMoney: 'Apply Money',
  bankCardNo: 'Bank Card No',
  status: 'Status',
  updataTime: 'Approval time',
  application: 'Application',
  success: 'Success',
  fail: 'Fail',
  failureReason: 'Failure reason',
  chinaBankCard: 'China Bank Card',
  internationalBankCard: 'International bank card',

}

export const points = { // 点券相关
  pointsInadequateTip: 'credit quantity not satisfied',
  selectedBudgetPointsTip: 'Recharge limit has been selected, please select payment method for payment',
  points: 'credit',
  myPoints: 'My credit',
  pointsRecharge: 'Credit recharge',
  pointsRecord: 'Credit record',
  rechargeAmountTip: 'Please enter the recharge amount',
  myAccountVoucher: 'My account voucher',
  paymentAmount: 'Payment amount',
  wechatPay: 'Wechat',
  alipay: 'Alipay',
  walletPay: 'WalletPay',
  recharge: 'Recharge',
  reminder: 'Reminder',
  pointTip: 'Ximei credit have no service life. You can use them for publishing projects, bidding projects, etc',
  rechargeSucTip: 'Recharge succeeded',
  totalPointsCountAR: 'Total credit count after recharge',
  changeTime: 'Change time',
  beforeChange: 'Before change',
  changeQuantity: 'Change quantity',
  afterChange: 'After change',
  reason: 'Reason',
  recharged: 'Recharged',
  postProject: 'Post project',
  registeredGift: 'Registered gift',
  nopoints:'Insufficient coupon balance, go to recharge',
  achivement:'Achivement',
  achivementr:'Achivement',
  progress:'Progress',
  receiveAward: 'Receive Award',
  received: 'Received'

}
export const recharge = { // 充值相关

  selectedBudgetPointsTip: 'Recharge limit has been selected, please select payment method for payment',
  recharge: 'recharge',
  myRecharge: 'My recharge',
  recharge: 'Recharge',
  rechargeRecord: 'Credit record',
  changeRecord: 'Trade record',
  rechargeAmountTip: 'Please enter the recharge amount',
  myAccountVoucher: 'My account voucher',
  paymentAmount: 'Amount',
  wechatPay: 'Wechat',
  alipay: 'Alipay',
  recharge: 'Recharge',
  reminder: 'Notice',
  pointTip: 'InfoTikx e-wallet is an electronic account created  Infotikx users. It integrates the payment of balance, Credit point purchase and management, and promotion coupon exchange. It is suitable for payment of project funds on InfoTikx.com management of personal balance and binding bank cards, etc.',
  rechargeSucTip: 'Recharge succeeded',
  totalPointsCountAR: 'Total credit count after recharge',
  changeTime: 'Change time',
  beforeChange: 'Before change',
  changeQuantity: 'Change quantity',
  afterChange: 'After change',
  reason: 'Reason',
  recharged: 'Recharged',
  rechargedPoints: 'RechargedPoints',
  postProject: 'Post project',
  payProjectFee: 'Pay project fee',
  acceptProjectFee: 'Accept project fee',
  registeredGift: 'Registered gift',
  nextTip: 'I have finished the payment, click next',
  payMilestones: 'Pay milestones fee',
  acceptMilestones: 'Accept milestones fee',
  refundMilestones: 'Milestone Commission Refund',
  payArbitrationFee: 'Pay arbitration fee',
  refundArbitrationFee: 'Refund arbitration fee',
  payIdentityFee: 'Pay identity fee',
  stripePayTips: 'If the amount is less than ¥4.00, Stripe payment is not supported.',
}

export const admin = { // 后台管理界面相关
  selfHelpQAndA: 'Self help Q&A',
  actualEntry: 'Actual entry',
  entryTime: 'Entry time',
  accountsReceivable: 'Accounts receivable',
  recordStatus: 'Record status',
  unrecorded: 'Unrecorded',
  recorded: 'Recorded',
  industryAndSkill: 'Industry & skill',
  edit: 'Edit',
  name: 'Name',
  billToBePaid: 'Bill to be paid',
  pendingReceipt: 'Pending receipt',
  statementType: 'Statement type',
  subjectMatter: 'Subject matter',
  uncollected: 'Uncollected',
  received: 'Received',
  receivedStatus: 'Received status',
  receivedTime: 'Received time',
  paymentChannel: 'Payment channel',
  realPayment: 'Real payment',
  currentPeriod: 'Current period',
  paymentStatus: 'Payment status',
  actuallyReceived: 'Project actually received',
  receivables: 'Project receivables',
  platformFee: 'Platform fee',
  totalFee: 'Total fee',
  payable: 'Payable',
  analystName: 'Talent name',
  customerName: 'Client name',
  projectName: 'Project name',
  projectPeriod: 'Project period',
  projectManage: 'Project manage',
  operationGuidanceEdit: 'Operation guidance edit',
  homePageSetting: 'Home page Setting',
  systemSetting: 'System setting',
  pointsManage: 'Credit manage',
  basicSettingsOfPoints: 'Basic settings credit',
  rechargeOrder: 'Recharge order',
  platformUserStatistics: 'Platform user statistics',
  userManagement: 'User management',
  totalPlatformUsers: 'Total platform users',
  total: 'Total',
  newUsersThisMonth: 'New users this month',
  paymentType: 'Payment type',
  paymentTime: 'Payment time',
  orderNumber: 'Order number',
  projectId: 'Project ID',
  creatorId: 'Creator ID',
  createTime: 'Create time',
  orderStatus: 'Order status',
  money: 'Money(¥)',
  unpaid: 'Unpaid',
  failed: 'Failed',
  successful: 'Successful',
  closed: 'Closed',
  enterOrderNumberTip: 'Please enter the order number',
  enterProjectIDTip: 'Please enter project ID',
  systemIdentificationCode: 'System identification code',
  base: 'Base',
  explain: 'Explain',
  savePointsBaseTip: 'Are you sure you want to save it?',
  orderManagementOfCountingAndRecharging: 'Order management of counting and recharging',
  pointsIncome: 'Credit income',
  entered: 'Entered',
  unEntered: 'Un entered',
  user: 'User',
  pointsNum: 'Credit values',
  sendingSystemMsg: 'Sending system messages',
  enterMsgTitleTip: 'Please enter the message title',
  sendToAll: 'Send to all',
  sendToAllCus: 'Send to all Client',
  sendToAllAna: 'Send to all talent',
  filterByCondition: 'Filter by condition',
  sendSystemMsgTip: 'Are you sure you want to send it?',
  sendMail: 'Send mail',
  registrationTime: 'Registration time',
  msgTitleEmptyTip: 'Message Title cannot be empty!',
  msgContentEmptyTip: 'Message content cannot be empty!',
  msgReceiverEmptyTip: 'Please select the recipients first!',
  msgSendSucTip: 'Message sent successfully!',
  msgSendFailTip: 'Message sending failed!',
  avatar: 'Avatar',
  operation: 'Operation',
  userAvatarReview: 'User avatar review',
  modificationTime: 'Modification time',
  adopt: 'Adopt',
  fail: 'Fail',
  whyFail: 'Fail details',
  template: 'Template',
  details: 'Details',
  operationSucceeded: 'Operation succeeded!',
  operationFailed: 'Operation failed!',
  operationSucceededAndNotice: 'The operation is successful, and a message is successfully sent to inform the user!',
  pleaseEnter: 'Please enter the content',
  areYouSure: 'Are you sure?',
  memberManagement: 'Member management',
  basicSettingsOfVip: 'Basic member settings',
  platformFeeRateSetting: 'Platform fee rate setting',
  projectCommission: 'Project commission rate',
  arbitrationFee: 'Arbitration fee',
  minimumCost: 'Minimum cost',
  memberPurchaseOrder: 'Member purchase order',
  annualFee: 'Annual fee',
  monthlyFee: 'Monthly fee',
  monthlyPrice: 'Price / month',
  monthlyOriginalPrice: 'Original price / month',
  yearPrice: 'Price / year',
  yearOriginalPrice: 'Original price / year',
  memberPurchaseOrderManagement: 'Member purchase order management',
  monthsPurchased: 'Months purchased',
  memberIncome: 'Income of members',
  purchasedMembers: 'Purchased members',
  projectCostManagement: 'Project cost management',
  platformFeeManagement: 'Platform fee management',
  arbitrationManagement: 'Arbitration management',
  authManagement: 'Auth management',
  billManagement: 'Bill management',
  userStatement: 'User statement',
  analystStatement: 'Talent statement',
  userBill: 'User bill',
  analystBilling: 'Talent billing',
  paymentMethod: 'payment method',
  collectionAccount: 'Collection account',
  sillsSet: 'skillSettings',
  withdrawal: 'Withdrawal',
  withdrawalApproval: 'Withdrawal approval',
  WithdrawalRecord: 'Withdrawal record',
  feedback: 'Feedback',
  help:'Help',
  withdrawalAgreement: 'Withdrawal agreement',
  systemContent: 'System content',
  activeUsers: 'Active users',
  multipleVisits:'Multiple visits',
  lastLoginTime: 'Last Login',
  sumLogin: 'Logins',
  published: 'Published',
  biddingSum: 'Bidding',
  undertakedSum: 'Undertaked',
  finishSum: 'Finished',
  clientGrade: 'Client Grade',
  talentGrade: 'Talent Grade',
  goodViews: 'Good Views',
  badViews: 'Bad Views',
  showActiveUsers: 'Active users',
  registerTimeStart: 'Register time(Start)',
  registerTimeEnd: 'Register time(End)',
  completed: 'Completed',
  pending: 'Pending',
  applicationUserId:'userId',
  applicationUserName:'userName',
  applicationTime:'application time',
  creatorName:'Creator',
}

export const pay = { // 支付相关
  weChatPay: 'Wechat payment',
  aliPay: 'Alipay payment',
  walletPay: 'Wallet payment',
  payType: 'Payment method',
  paymentAmount: 'Payment amount',
  platformFee: 'Platform fee',
  orderPrice: 'Order price',
  paid: 'I have paid',
  payConfirm: 'Confirm payment',
  paySucTip: 'Payment successful',
  payFailTip: 'No payment information found',
  InsufficientBalance: 'Insufficient balance',
  projectCostTip: 'The cost is the project cost, which will be kept by infotikx platform. The project cost will not be paid to talent until the project is accepted.',
  paymentInformation: 'Payment information',
  paymentMatters: 'You are paying for the project. This payment is protected by the Infortikx payment system and is released to the talent account when you agree to release the amount.',
  payMilestoneMatters: 'You are paying for the milestone fee. The payment is protected by Infortikx Payment System, when you choose to release the milestone commission, the amount will be automatically released to the corresponding talent account.',
  payArbitrationMatters: 'The payment is for arbitration fees. If your arbitration is successful, the payment will be returned to your account.',
  createMilestoneMatters: 'The client will need to approve these updates. We’ll notify them and let you know if these changes are approved. ',
  cancelPay: 'Payment cancel',
  payByWalletTip: 'Whether to use wallet for payment?'
}

export const stage = { // 项目分期相关
  stageMinTip: 'The installment cannot be less than two',
  phase: 'Phase',
  days: 'Days',
  closingDate: 'Closing date',
  projectProportion: 'Project proportion',
  paymentProportion: 'Payment proportion',
  delivery: 'Delivery',
  currentDeliveryPhase: 'Current delivery phase',
  pass: 'Pass',
  fail: 'Fail',
  done: 'Done',
  notDone: 'Not done'
}

export const history = { // 项目历史相关
  publishProject: 'Publish project',
  winningBid: 'Winning the bid',
  uploadProduct: 'Upload product',
  deleteProduct: 'Delete product',
  submitComments: 'Submit comments',
  acceptancePassed: 'Acceptance passed',
  acceptanceFailed: 'Acceptance failed',
  projectCompletion: 'Project completion',
  paymentReceived: 'Payment received',
  trading: 'In progress',
  review: 'Review',
  cancel: 'Cancelled',
  dispute: 'In dispute',
}

export const chatSystemMsg = { // 实时聊天相关
  tipOne: "The other party has not replied. You can't continue sending messages"
}

export const vip = { // 会员相关
  memberUpgrade: 'Member upgrade',
  vip:'Membership',
  vipCenter: 'Membership center',
  nonVip: 'Ordinary users',
  silverVip: 'Basic vip',
  goldMedalVip: 'Plus+ vip',
  platinumVip: 'Premium vip',
  purchaseRecord: 'Purchase record',
  hello: 'Hello',
  upgradeVipGainPrivileges: 'Upgrade to a member and enjoy more member privileges',
  member: 'member',
  honorable: 'Hello, dear',
  expirationTime: 'Expiration time',
  monthly: '/1 month',
  yuanMonth: ' Yuan / month',
  originalPrice: 'Original price',
  renewNow: 'Renew now',
  buyVip: 'Buy member',
  annually: '/1 year',
  vipPrivileges: 'Membership privileges',
  purchaseTime: 'Purchase time',
  formerlyVipState: 'Member status before order',
  purchasedVip: 'Purchased members',
  purchasedDuration: 'Purchase duration (month)',
  upgradeVip: 'Upgrade to member',
  wechatScan: 'Open wechat "sweep"',
  alipayScan: 'Open Alipay "sweep"',
  scanningPayment: 'Scan the QR code below to complete the payment',
  openingTime: 'Opening time',
  oneMonth: '1 month',
  threeMonths: '3 months',
  sixMonths: '6 months',
  oneYear: '1 year',
  paymentMethod: 'Payment method',
  wechatPay: 'WeChat',
  aliPay: 'Alipay',
  paymentAmount: 'Payment amount',
  yuan: 'Yuan',
  explain: 'Note: no refund is supported after the member service is opened',
  buyNow: 'Buy now',
  cancel: 'Cancel',
  successTips: "Successfully purchased member",
  openVipFirst: 'Open Basic',
  openVipSecond: 'Open Plus+',
  openVipThird: 'Open Premium',
  renewalVipFirst: 'Renew Basic',
  renewalVipSecond: 'Renew Plus+',
  renewalVipThird: 'Renew Premium',
  upgradeVipSecond: 'Upgrade to Plus+',
  upgradeVipThird: 'Upgrade to Premium',
  upgradeNow: "Upgrade now",
  validUntil: "Valid until",
  morePrivilege: 'Enjoy more privileges',
  calculationUpgradePriceError: 'Failed to obtain the price difference, please contact customer service!',
  tips:'The current page is displayed temporarily as a simple template'
}

export const search = { // 搜索功能相关
  industrySkills: 'Industry&Skills',
  select: 'Select',
  budget: 'Budget',
  duration: 'Time limit for the project  (days)',
  release: 'Publish date',
  status: 'Project status',
  public: 'Open to the public',
  sort: 'Sort',
  all: 'All',
  default: 'Default',
  today: 'Today',
  week: 'Past week',
  twoWeeks: 'Past two weeks',
  month: 'Past month',
  threeMonths: 'Past three months',
  overThree: 'Over three months',
  notExpired: 'Ongoing',
  expired: 'Expired',
  public: 'Public project',
  private: 'Private project',
  budgetScope: 'Budget',
  projectDuration: 'Time limit for the project',
  SkillRequirements: 'Skill requirements',
  joinBid: 'Go bid',
  deadline: 'Deadline',
  releaseTime: 'Release time',
  biddingTotal: 'Bider',
  BudgetDuration: 'Budget',
  grade: 'Grade',
  publishProject: 'Publish',
  more: 'More than 360',
  completed: 'Completed project(s)',
  oneStar: '≥One star',
  twostars: '≥Two stars',
  threestars: '≥Three stars',
  fourstars: '≥Four stars',
  fiveStars: 'Five stars',
  moreThan500: 'More than 500',
  days: 'Days',
  recently: 'Recent Updates',
  highestPrice:'Highest price',
  maximumDuration: 'Maximum duration',
  bestEvaluation: 'Best evaluation',
  clearOptions: 'Clear Options',
  moreFive:'Select up to 5 tags',
  inviteWarn:"You can't invite yourself"
}

export const index = { //首页
  toHire: 'To hire',
  tips1: 'Discover talent and hire them to take your business to the next level.',
  findWork: 'Find work',
  tips2: 'You have top skills, find a job that fits your skills.',
  bestPick: 'Evaluate Top10',
  GoodBargin: 'Bargin Top10',
  bestNewcomer: 'Newcomer Top10',
  latestPosts: 'Latest posts',
  more: 'See more',
  talent: 'Talent',
  project: 'Project',
  bannerTitle:'Hire the best talents for your business, online',
  bannerText:'Infotikx, a global knowledge exchange marketplace leads your way to success.',
  bannerTitle1: 'Online, find the best project for you',
  bannerText1: 'Infotikx is a global international knowledge trading platform to find your niche',
  bannerTitle2: 'Online, hire the best talent and find the best project for you',
  bannerText2: 'Looking for jobs or talent? 8 billion people around the world, Infotikx platform will bring you the best user experience',
  toHire:'To hire',
  findwork:'Find work',
  seationTitle:'Make it Real',
  seationTitle1:"Grow your business smart with us",
  postJob:'Post a job',
  chooseInfotikx:'Choose Infotikx',
  paySafely:'Pay safely',
  help:'We’re here to help',
  browsePortfolios:'Get your money spent right',
  fastBids:'Quality work done right now',
  qualityWork:'Professional team works for you',
  Trackprogress:'Track progress',
  seationPart1:'It’s free and easy to post a job. Simply fill in a title, description and budget and competitive bids come within minutes.',
  seationPart2:"No job is too big or too small. We've got infotikx for jobs of any size or budget, across 1800+ skills. No job is too complex. We can get it done!",
  seationPart3:"Only pay for work when it has been completed and you're 100% satisfied with the quality using our milestone payment system.",
  seationPart4:'Our talented team of recruiters can help you find the best infotikx for the job and our technical co-pilots can even manage the project for you.',
  seationPart5:'No hourly rates, just project-based pricing. Find the right talent that worth every penny you spent. Your payment isn’t released until you approve the project.',
  seationPart6:'Find your right talent to begin working for you right now. Quickly build your business around your needs.',
  seationPart7:'Our support team is always here with you, making sure your payment is secured, your problem is handled, and your experience is improved.',
  seationPart8:"Keep up-to-date and on-the-go with our time tracker, and mobile app. Always know what infotikx are up to.",
  seeMore:'See More',
  footSeationTitle1:'Work anywhere anytime',
  footSeationTitle2:'Find talent that works your way',
  footSeationText1:'Meet clients you’re excited to work with and take your career to another level.',
  footSeationText2:'Forget the old rules. Find the best talent to work for you right here and right now.',
  joinUs:'Find a job',
  findTalent: 'Find a talent',
  ContactUs:'Contact us',
  tel:'Tel'


}

export const role = { // 角色相关
  changeRole: 'Change role',
  currentRole: 'Current role',
  roleNickname: 'Role nickname',
  joinTiem:'Joining Time',
  personalIntroduction:'Personal Introduction',
  caseIntroduction:'Case Introduction',
  comments:'Project Comments',
  evaluationScore:'Evaluate his score',
  evaluationContent:'The content of his evaluation',
  resume:'Resume',
  myWorks: 'My Production',
  individualWorks: 'My Production',
  clickupload: 'Click Upload',
  friendlyReminder: 'Warm Remind',
  upgradeMember: 'Upgrade Member',
  uploadTip1: 'Currently, you can only upload ',
  uploadTip2: ' file works, and more works can be uploaded by upgrading the membership level.',
  deleteTip: 'This action will remove the file from the list. Do you want to continue?',
}
export const bill = { // 账单相关
  statement: 'My statement',
  myBill: 'My bill',
  payProjectFee: 'Project fee taken',
  receiveProjectFee: 'Project fee received',
  payMilestone: 'Milestone Payment for project',
  receiveMilestone: 'Milestone received',
  payPlatformFee: 'Platform fee',
  rechargePoints: 'Recharge Points',
  rechargeWallet: 'Recharge Wallet',
  rechargeVip: 'Recharge Vip',
  date: 'Date',
  transaction: 'Transaction',
  amount: 'Amount',
  balance: 'Balance',
  payByWechat: 'pay by wechat',
  payByAli: 'pay by ali',
  payByWallet: 'pay by wallet',
}
export const dispute = { // 争议
  stage:'stage',
  stage1:'IDENTIFY THE ISSUE',
  stage2:'NEGOTIATIONS',
  stage3:'FINAL OFFERS/EVIDENCE',
  stage4:'ARBITRATION',
  stage1Tips1:'Most disputes are the result of a simple misunderstanding.',
  stage1Tips2:'Our dispute resolution system is designed to allow both parties to resolve the issue amongst themselves.',
  stage1Tips3:'Most disputes are resolved without arbitration.',
  stage1Tips4:'If an agreement cannot be reached,either party may elect to pay an arbitration fee for our dispute team to resolve the matter.',
  stage2Tips1:'Infotikx strongly recommend that you have clear communication with the other party to resolve issues.',
  stage2Tips2_1:'Notice: If employer fails to communicate within 14 days after raising the dispute, it will be in favor of employee.',
  stage2Tips2_2:'Notice: If employee fails to communicate within 4 days after raising the dispute, it will be in favor of employer.',
  stage2Tips3:'Either party can choose to escalate the dispute to the third stage by paying a arbitration fee after 4 days. During this stage, the other party will have 4 days to agree to pay the fee and submit final evidence. The arbitration fee will be refunded to the winner of the dispute.',
  stage3Tips1:'If either party refuses to settle the dispute and pay the arbitration fees, the dispute will enter this stage. This is your final opportunity to resolve disputes between each other and also your last chance to submit evidence supporting your case.',
  stage4Tips1:'The dispute panel will review all the evidence and other information provided to make a decision (usually within 48 hours). The dispute ruling is final, binding, and irreversible.',
  disputeDescTips:'Please provide a detailed description of the milestone requirements you wish to dispute:',
  disputeUploadFileTips1:'Make sure you have uploaded evidence for each milestone requirement that has been completed. Please include how the evidence of meeting the milestone requirements was communicated.',
  disputeUploadFileTips2:'You can attach your case.',
  solution:'Solution',
  inProgress:'In Progress',
  cancelled:'Cancelled',
  resolved:'Resolved',
  overdue:'Overdue',
  arbitration:'Arbitration',
  waitResponse:'Wait Response',
  success:'success',
  failure:'failure',
  disputeAmount:'Total disputed amount',
  createTime:'Initiation Time',
  negotiations:'Negotiations',
  createDispute:'Create new dispute',
  wait:'wait',
  response:'response',
  wantReceive:'wants to receive:',
  releaseAmount:'Agree',
  acceptArbitration:'Accept arbitration',
  cancelDispute:'Cancel Dispute',
  applyArbitration:'Apply arbitration',
  releaseAmountTips:'Confirm?',
  applyArbitrationTips1:'Confirm accept arbitration?',
  cancelDisputeTips:'Confirm cancel dispute?',
  applyArbitrationTips2:'Confirm apply Arbitration?',
  disputeTitle:'Dispute Resolution Process',
  uploadFileTips: 'Up to one attachment can be uploaded. The supported formats are. JPG,. PNG',
  overdueTips:'Automatically handle timeouts',
  viewEvidence:'View evidence',
  arbitrationSuccess:'Success',
  arbitrationFail:'Fail',
  applyArbitrationTips:'Arbitration can only be applied after four days of negotiation',
  disputeNo:'Dispute No',
  evidenceList:'Evidence List',
}
export const auth = { // 认证
  liftPotential:'Lift your potential.',
  getVerified:'Get Verified by InfoTikx.',
  bannerDesc:'Lift your profile to the next level by becoming Verified by InfoTikx. The blue badge lets people know that your account is authentic and that you have gone through a process to verify identity that includes a video interview.',
  accessDesc:'Verified by InfoTikx:',
  bannerList1:'Projects worth $2,500.00 USD+',
  bannerList2:'Hourly projects over $50 USD',
  bannerList3:'Winning more jobs, more easily',
  standTitle1:'Stand out from the crowd',
  standContent1:'Spend less time hunting, more time winning. Verified freelancers are rewarded with a distinct and highly recognizable badge that makes sure that clients notice them first, increasing their chances of being awarded. Let clients come to you rather than wasting bids.',
  standTitle2:'Increase Confidence',
  standContent2:'Being Verified by InfoTikx means that you gone through a video interview process with InfoTikx staff. This will help clients recognize you as an authenticated member of InfoTikx.',
  standTitle3:'Bid on projects worth $2,500.00 USD',
  standContent3:'Verified by InfoTikx allows exclusive access to longer, more interesting, and better paying projects. Only Verified by InfoTikx can bid on projects worth $2,500.00 USD or more.',
  standLine:'"After I got Verified, I started winning more projects. My clients really appreciated that I went through the extra step to verify myself. It removed a lot of the friction."',
  clientTitle:'Show clients the person behind the profile!',
  clientContent:'Verified by InfoTikx where you can show the client why you are the perfect freelancer for the job. Your bid will also stand out with an animated border, increasing the visibility of your bid. Your bids are 25% more likely to be chatted to and awarded!',
  gettingTopTitle:'Getting started is easy',
  gettingTitle1:'What is required?',
  gettingTitle2:'How long does it take?',
  gettingTitle3:'What is the process?',
  getting1Desc1:'To apply you must have an up to date profile and be:',
  getting1Desc2:'Email verified',
  getting1Desc3:'Phone verified',
  getting1Desc4:'Payment verified',
  getting1Desc5:'KYC verified',
  getting2Desc:'After applying our agents will begin reviewing your application. This process is usually complete within 1 to 2 business days.',
  getting3Desc:'After your application has been reviewed, one of our agents will contact you to schedule a video interview. If your interview is successful then your new blue Verified badge will be activated.',
  gettingBottomDesc:'The application fee is non-refundable, even if you do not end up meeting the requirements to be a Verified Freelancer.  For more information,please refer to our FAQ.',
  winTitle:'Win more jobs, more easily',
  winDesc:'Clients want to work with trustworthy freelancers that are serious about their career. Verified by InfoTikx tells clients that you have taken the extra step to let them know that you mean business.',
  getStarted:'Get started',
  successDialogTitle:'You have been verified',
  waitDialogTitle:'You have already submitted an application',
  inProgressDialogTitle:'You are one step closer to being verified',
  inProgressTips:'The Verified process includes examining your verification documents, your profile and possibly a video call with our team. We will reach out  once your application has been submitted.',
  successTips:'Congratulations! Your application has been approved, making you a certified on our platform. You can now start accepting tasks, showcasing your skills, and collaborating with users. Thank you for choosing us, and we look forward to your continued success here!',
  waitTips:'Thank you for submitting your application! Your application has been successfully sent to our review team, and we will review it as soon as possible. Thank you for choosing our platform, and we look forward to establishing a partnership with you!',
  errTips:'It looks like you are missing some of the requirements to continue the Verified process. Please complete these to proceed.',
  requirement:'Requirement',
  profileVerified:'profile Verified',
  paymentVerified:'payment Verified',
  KYCVerified:'Identity (KYC) Verified',
  profileVerification:'Complete profile verification',
  paymentVerification:'Complete bankCard verification',
  kycVerification:'Complete your KYC',
  here:'here',
  failReason:'Reason for failure',
  inputReason:'Please enter the reason for failure',
  reason:'Reason',
  applicationFailed:'Your application has been rejected',
}

export const userDetails = {
  back: 'Return',
  avatar: 'Avatar',
  nickname: 'Nickname',
  auth: 'Authentication',
  username: 'Username',
  email: 'Email',
  realname: 'Realname',
  role: 'Role',
  userStatus: 'User status',
  idNumber: 'ID number',
  address: 'Address',
  yes: 'Yes',
  no: 'No',
  typeCode1: 'Employer',
  typeCode2: 'Personnel',
  typeCode3: 'Finance',
  typeCode4: 'Super administrator',
}



// WEBPACK FOOTER //
// ./src/common/lang/en.js